<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="sign-log-table-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 搜索栏 -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <el-input
            v-model="searchParams.user_id"
            placeholder="请输入用户ID"
            clearable
            style="width: 200px"
          ></el-input>

          <el-button type="primary" @click="getList">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>

        <!-- PC表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="用户ID" prop="user_id" width="120" align="center" />
          <el-table-column label="签到天数" prop="days" width="100" align="center" />
          <el-table-column label="签到类型" width="110" align="center">
            <template slot-scope="scope">
              {{ scope.row.type === 1 ? '钻石' : '特殊签到' }}
            </template>
          </el-table-column>
          <el-table-column label="签到日期" prop="sign_date" width="130" align="center" />
          <!-- <el-table-column label="是否发放奖励" width="120" align="center">
            <template slot-scope="scope">
              <span :style="{color: scope.row.is_send ? '#67c23a' : '#f56c6c'}">
                {{ scope.row.is_send ? '已发放' : '未发放' }}
              </span>
            </template>
          </el-table-column> -->
          <el-table-column label="今日流水" prop="pay_price" width="130" align="center" />
          <el-table-column label="周期阶段" width="110" align="center">
            <template slot-scope="scope">第{{ scope.row.phase }}阶段</template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" min-width="180" align="center" />
        </el-table>

        <!-- PC分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC详情弹窗 -->
        <el-dialog title="签到记录详情" :visible.sync="detailVisible" width="600px" append-to-body>
          <el-form :model="detailForm" label-width="120px" size="small">
            <el-form-item label="记录ID"><span>{{ detailForm.id || '-' }}</span></el-form-item>
            <el-form-item label="用户ID"><span>{{ detailForm.user_id || '-' }}</span></el-form-item>
            <el-form-item label="签到天数"><span>{{ detailForm.days || '-' }}</span></el-form-item>
            <el-form-item label="签到类型">
              <span>{{ detailForm.type === 1 ? '钻石' : '特殊签到' }}</span>
            </el-form-item>
            <el-form-item label="签到日期"><span>{{ detailForm.sign_date || '-' }}</span></el-form-item>
            <!-- <el-form-item label="奖励发放状态">
              <span :style="{color: detailForm.is_send ? '#67c23a' : '#f56c6c'}">
                {{ detailForm.is_send ? '已发放' : '未发放' }}
              </span>
            </el-form-item> -->
            <el-form-item label="今日流水"><span>{{ detailForm.pay_price || '0.00' }}</span></el-form-item>
            <el-form-item label="周期阶段"><span>第{{ detailForm.phase }}阶段</span></el-form-item>
            <el-form-item label="创建时间"><span>{{ detailForm.created_at || '-' }}</span></el-form-item>
            <el-form-item label="更新时间"><span>{{ detailForm.updated_at || '-' }}</span></el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-log-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 移动端搜索 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.user_id"
            placeholder="用户ID"
            clearable
            size="medium"
            prefix-icon="el-icon-user"
          />
          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button type="primary" plain round @click="getList" style="flex: 1">搜索</el-button>
            <el-button plain round @click="resetSearch" style="flex: 1">重置</el-button>
          </div>
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-top">
              <div class="id-info">
                <span>ID：{{ item.id }}</span>
                <span class="type-tag">{{ item.type ===1 ? '钻石':'特殊签到' }}</span>
              </div>
              <div class="amount" :class="item.is_send ? 'add' : 'reduce'">
                <!-- {{ item.is_send ? '已发奖励' : '待发放' }} -->
              </div>
            </div>
            <div class="card-middle">
              <div>用户ID：{{ item.user_id }}</div>
              <div>签到天数：{{ item.days }}天｜第{{item.phase}}阶段</div>
              <div>签到日期：{{ item.sign_date }}</div>
              <div>今日流水：{{ item.pay_price }}</div>
            </div>
            <div class="card-bottom">
              <div class="time">{{ item.created_at }}</div>
            </div>
          </div>
        </div>

        <!-- 移动端分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="签到详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            v-if="mobileDetailRow"
            :model="mobileDetailRow"
            label-width="100px"
            size="small"
          >
            <el-form-item label="记录ID">{{ mobileDetailRow.id }}</el-form-item>
            <el-form-item label="用户ID">{{ mobileDetailRow.user_id }}</el-form-item>
            <el-form-item label="签到天数">{{ mobileDetailRow.days }}</el-form-item>
            <el-form-item label="签到类型">{{ mobileDetailRow.type===1?'钻石':'特殊签到' }}</el-form-item>
            <el-form-item label="签到日期">{{ mobileDetailRow.sign_date }}</el-form-item>
            <!-- <el-form-item label="奖励状态">
              <span :style="{color: mobileDetailRow.is_send ? '#67c23a':'#f56c6c'}">
                {{ mobileDetailRow.is_send?'已发放':'未发放' }}
              </span>
            </el-form-item> -->
            <el-form-item label="今日流水">{{ mobileDetailRow.pay_price }}</el-form-item>
            <el-form-item label="周期阶段">第{{ mobileDetailRow.phase }}阶段</el-form-item>
            <el-form-item label="创建时间">{{ mobileDetailRow.created_at }}</el-form-item>
            <el-form-item label="更新时间">{{ mobileDetailRow.updated_at }}</el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "UserSignLog",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
      },
      detailVisible: false,
      detailForm: {},
      mobileDetailVisible: false,
      mobileDetailRow: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await api.logs.userSignLog({ params: this.searchParams });
        if (res.data.code === '1000') {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        }
      } finally {
        this.loading = false;
      }
    },
    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },
    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* PC */
.sign-log-table-container {
  padding: 20px;
}

/* 移动端样式和之前钻石日志统一 */
.mobile-log-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.id-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.type-tag {
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
}
.amount {
  font-weight: bold;
  font-size: 14px;
}
.amount.add {
  color: #67c23a;
}
.amount.reduce {
  color: #f56c6c;
}
.card-middle {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}
.card-bottom {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  padding-top: 8px;
  border-top: 1px dashed #f0f0f0;
}
</style>


// WEBPACK FOOTER //
// src/pages/log/signRecord.vue